import * as React from "react";
import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";

import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { IProductApprovalList } from "src/modules/product-approval/api/product-approval.api";

export interface IApprovalListColumns {
  //buttons for each list
  actionButton: (info: CellContext<IProductApprovalList, unknown>) => React.ReactNode,
  //ability to choose columns outside of this file
  columns?: ApprovalListColumnsPicked[]
}

type ApprovalListColumnsPicked = keyof AvailableApprovalListColumns;

interface AvailableApprovalListColumns{
  name: ColumnDef<IProductApprovalList, string | number | Date | null | undefined>,
  description: ColumnDef<IProductApprovalList, string | number | Date | null | undefined>,
  action: ColumnDef<IProductApprovalList, unknown>,

}

/** columns for Approval List Columns*/
export const getApprovalListColumns = (params: IApprovalListColumns) => {
  const customColumnHelper = customCreateColumnHelper<IProductApprovalList>();
  const ColumnHelper = createColumnHelper<IProductApprovalList>();

  const AllColumns: AvailableApprovalListColumns = {
    name: customColumnHelper.standardTextColumn(ColumnHelper, "name", { header: "Name" }),
    description: customColumnHelper.standardTextColumn(ColumnHelper, "description", { header: "Description" }),
    action: customColumnHelper.actionColumn(ColumnHelper, params.actionButton, {})
  };

  if (params.columns) {
    return params.columns.map(column => AllColumns[ column ]);
  } else {
    return Object.values(AllColumns);
  }
};
